(function () {
  'use strict';

  var cfg = window.__mcFreeGiftConfig || {};
  if (!cfg.enabled) return;

  var nativeFetch = window.fetch.bind(window);
  var syncing = false;
  var resolving = {};
  var resolvedAllProducts = null;

  function str(v) { return v == null ? '' : String(v); }
  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function makeIdSet(values) {
    return new Set((Array.isArray(values) ? values : []).map(str).filter(Boolean));
  }

  var rules = [
    {
      key: 'unity',
      label: 'Unity',
      collectionHandle: cfg.unityCollectionHandle || 'unity',
      giftProductId: str(cfg.unityGiftProductId),
      giftVariantId: str(cfg.unityGiftVariantId),
      eligibleProductIds: makeIdSet(cfg.unityEligibleProductIds)
    },
    {
      key: 'shaheen',
      label: 'Shaheen',
      collectionHandle: cfg.shaheenCollectionHandle || 'shaheen',
      giftProductId: str(cfg.shaheenGiftProductId),
      giftVariantId: str(cfg.shaheenGiftVariantId),
      eligibleProductIds: makeIdSet(cfg.shaheenEligibleProductIds)
    }
  ].filter(function (r) { return r.collectionHandle && r.giftProductId; });

  async function jsonFetch(url, options) {
    var res = await nativeFetch(url, options || { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Request failed: ' + url);
    return res.json();
  }

  async function getAllProducts() {
    if (resolvedAllProducts) return resolvedAllProducts;
    try {
      var data = await jsonFetch(rootUrl('collections/all/products.json?limit=250'));
      resolvedAllProducts = data.products || [];
    } catch (e) {
      resolvedAllProducts = [];
    }
    return resolvedAllProducts;
  }

  async function resolveRule(rule) {
    if (rule._resolved) return rule;
    if (resolving[rule.key]) return resolving[rule.key];

    resolving[rule.key] = (async function () {
      var products = [];
      var needsCollectionFetch = !rule.eligibleProductIds || !rule.eligibleProductIds.size || !rule.giftVariantId;

      if (needsCollectionFetch) {
        try {
          var data = await jsonFetch(rootUrl('collections/' + encodeURIComponent(rule.collectionHandle) + '/products.json?limit=250'));
          products = data.products || [];
        } catch (e) {
          console.warn('[Maison Free Gift] Could not load collection:', rule.collectionHandle);
        }
      }

      if (!rule.eligibleProductIds || !rule.eligibleProductIds.size) {
        rule.eligibleProductIds = new Set(
          products.map(function (p) { return str(p.id); }).filter(function (id) { return id && id !== rule.giftProductId; })
        );
      }

      if (!rule.giftVariantId) {
        var giftProduct = products.find(function (p) { return str(p.id) === rule.giftProductId; });
        if (!giftProduct) {
          var allProducts = await getAllProducts();
          giftProduct = allProducts.find(function (p) { return str(p.id) === rule.giftProductId; });
        }
        if (giftProduct && giftProduct.variants && giftProduct.variants.length) {
          var available = giftProduct.variants.find(function (v) { return v.available !== false; }) || giftProduct.variants[0];
          rule.giftVariantId = str(available.id);
        }
      }

      if (!rule.eligibleProductIds || !rule.eligibleProductIds.size) {
        console.warn('[Maison Free Gift] No qualifying products were resolved for', rule.label, 'collection:', rule.collectionHandle);
      }
      if (!rule.giftVariantId) {
        console.warn('[Maison Free Gift] No gift variant was resolved for', rule.label, 'gift product:', rule.giftProductId);
      }

      rule._resolved = true;
      return rule;
    })();

    try { return await resolving[rule.key]; }
    finally { delete resolving[rule.key]; }
  }

  function itemProductId(item) { return str(item.product_id); }
  function isRuleGiftItem(item, rule) {
    return itemProductId(item) === rule.giftProductId || (item.properties && item.properties._mc_free_gift === rule.key);
  }

  async function addGift(rule) {
    if (!rule.giftVariantId) {
      console.warn('[Maison Free Gift] Variant ID could not be resolved for', rule.label, 'gift product', rule.giftProductId);
      return false;
    }

    var res = await nativeFetch(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: rule.giftVariantId,
        quantity: 1,
        properties: { _mc_free_gift: rule.key, _mc_gift_for: rule.collectionHandle }
      })
    });

    if (!res.ok) {
      var detail = '';
      try { detail = await res.text(); } catch (e) {}
      console.error('[Maison Free Gift] Could not add', rule.label, 'gift. Variant:', rule.giftVariantId, detail);
      return false;
    }
    return true;
  }

  async function changeItem(key, quantity) {
    await jsonFetch(rootUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function ensureToastRoot() {
    var el = document.getElementById('mc-free-gift-toast-root');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'mc-free-gift-toast-root';
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    return el;
  }

  function showToast(rule) {
    if (!cfg.showToast) return;
    var root = ensureToastRoot();
    var toast = document.createElement('div');
    toast.className = 'mc-free-gift-toast';
    toast.innerHTML = '<div class="mc-free-gift-toast__icon">♡</div>' +
      '<div><strong>Complimentary Gift Added</strong><span>Your handmade crochet ' + rule.label + ' keychain has been added to your cart.</span></div>' +
      '<button type="button" aria-label="Close">×</button>';
    root.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    var close = function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 250);
    };
    toast.querySelector('button').addEventListener('click', close);
    setTimeout(close, 4800);
  }

  async function refreshCartUI(cart) {
    var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') {
      try { await drawer.refresh(cart); } catch (e) {}
    }
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  async function syncGifts(options) {
    options = options || {};
    if (syncing || !rules.length) return null;
    syncing = true;
    var changed = false;
    var addedRules = [];

    try {
      await Promise.all(rules.map(resolveRule));
      var cart = await jsonFetch(rootUrl('cart.js'));

      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        var qualifies = (cart.items || []).some(function (item) {
          return rule.eligibleProductIds && rule.eligibleProductIds.has(itemProductId(item)) && !isRuleGiftItem(item, rule);
        });
        var giftItems = (cart.items || []).filter(function (item) { return isRuleGiftItem(item, rule); });

        if (qualifies) {
          if (!giftItems.length) {
            var added = await addGift(rule);
            if (added) { changed = true; addedRules.push(rule); cart = await jsonFetch(rootUrl('cart.js')); }
          } else {
            for (var g = 0; g < giftItems.length; g++) {
              if (g === 0 && giftItems[g].quantity !== 1) {
                await changeItem(giftItems[g].key, 1); changed = true;
              } else if (g > 0) {
                await changeItem(giftItems[g].key, 0); changed = true;
              }
            }
            if (changed) cart = await jsonFetch(rootUrl('cart.js'));
          }
        } else if (giftItems.length) {
          for (var r = 0; r < giftItems.length; r++) {
            await changeItem(giftItems[r].key, 0);
            changed = true;
          }
          cart = await jsonFetch(rootUrl('cart.js'));
        }
      }

      if (changed) {
        await refreshCartUI(cart);
        if (options.notify !== false) addedRules.forEach(showToast);
        document.dispatchEvent(new CustomEvent('mc:free-gifts-synced', { detail: { cart: cart } }));
      }
      return cart;
    } catch (e) {
      console.error('[Maison Free Gift]', e);
      return null;
    } finally {
      syncing = false;
    }
  }

  var mutationRe = /\/cart\/(add|change|update|clear)\.js(?:\?|$)/;
  window.fetch = async function () {
    var args = Array.prototype.slice.call(arguments);
    var input = args[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var response = await nativeFetch.apply(null, args);

    if (!syncing && mutationRe.test(url)) {
      try { await syncGifts({ notify: true }); } catch (e) {}
    }
    return response;
  };

  window.MaisonFreeGifts = {
    sync: function () { return syncGifts({ notify: false }); },
    rules: rules
  };

  function init() { syncGifts({ notify: false }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
